import styled from "styled-components";
import { Radio } from "antd";

// common
import { ModalLayout } from "common/modal";

const { ModalRow, ModalCol } = ModalLayout;

export const ProgramSelectorContainer = styled(Radio.Group)`
  flex-direction: column;
  width: 100%;
`;

export const ProgramDescription = styled(ModalCol)`
  display: flex;
  align-items: center;
  color: #707070;
  font-size: 16px;
  font-weight: bold;
  flex-wrap: wrap;

  @media only screen and (max-width: 480px) {
    & {
      align-items: flex-end;
      padding-bottom: 6px;
    }
  }
`;

export const ProgramOption = styled(Radio)`
  display: inline-flex;
  flex-direction: row;
  margin: 18px 0px;
  width: 100%;
  background-color: ${(props) => (props.checked ? "#D3E8FF" : "#F6F6F6")};
  border: ${(props) =>
    props.checked ? "solid 2px #1070B6" : "solid 2px #E4E4E4"};
  min-height: 75px;
  transition: border 0.25s;
  border-radius: 2px;

  & span.ant-radio {
    display: flex;
    min-width: 60px;
    align-items: center;
  }

  & .ant-radio-inner {
    width: 24px;
    height: 24px;
    flex-grow: 0 !important;
    margin-left: 18px;
  }

  & .ant-radio-inner::after {
    width: 16px;
    height: 16px;
  }

  & span:not(.ant-radio) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px;
    flex-grow: 1;
  }

  & ${ProgramDescription} {
    color: ${(props) => (props.checked ? "#1070B6" : "#707070")};
  }
  @media only screen and (min-width: 436px) and (max-width: 495px) {
    height: 131px;
  }
  @media only screen and (min-width: 575px) and (max-width: 715px) {
    height: 93px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1015px) {
    height: 131px;
  }
  @media only screen and (min-width: 1015px) and (max-width: 1285px) {
    height: 93px;
  }
`;

export const ProgramInfoContainer = styled(ModalRow)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const Price = styled(ModalCol)`
  display:flex;
  text-align: right;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 36px;
  color: #1070b6;
  font-weight: bold;
  padding-right: 18px;
  flex-wrap: wrap;

  @media only screen and (max-width: 480px) {
    & {
      padding-bottom: 8px;
    }
  }
  @media only screen and (min-width: 389px) and (max-width: 495px) {
    & {
      flex: 0 0 131px;
    }
  }
  @media only screen and (min-width: 575px) and (max-width: 715px) {
    & {
      flex: 0 0 131px;
    }
  }
  }
  @media only screen and (min-width: 1115px) and (max-width: 1285px) {
    & {
      flex: 0 0 131px;
    }
  }
`;

export const CurrencySign = styled.div`
  vertical-align: super;
  font-size: 20px;
  height: 100%;
  transform: scaleX(1.25);
`;

export const OutputPrice = styled.div`
  @media only screen and (min-width: 900px) and (max-width: 1015px) {
    width: 131px;
  }
  @media only screen and (min-width: 768px) and (max-width: 846px) {
    width: 131px;
  }
`;

export const PerUnitTime = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
  font-size: 18px;
  padding-bottom: 4px;
`;

export const ProgramHintText = styled.span`
  font-size: 12px;
  color: #777;
  font-weight: normal;
`;

type SubscriptionStatusTagProps = {
  gray?: boolean;
};
export const SubscriptionStatusTag = styled.span<SubscriptionStatusTagProps>`
  padding: 4px 10px !important;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0.8px;
  color: ${({ gray }) => (gray ? "#ffffff" : "#1070B6")};
  background-color: ${({ gray }) => (gray ? "#888888" : "#fdd440")};
  border-radius: 2px;
  flex-grow: 0 !important;
  margin-left: 10px;
  width: ${({ gray }) => (gray ? "85px" : "63px")};
`;
